export default __webpack_public_path__ + "static/media/strong  5 self assesment.fff1554e.jpeg";